<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-0 bg-logo"
        style="background-color:#3f3939"
      />

      <b-col
        lg="4"
        class="d-flex align-items-end auth-bg px-2 p-lg-5"
      >
        <b-row style="height: 75%; justify-content: space-between;">
          <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
          >
            <div style="display: flex">
              <b-card-title
                title-tag="h2"
                class="font-weight-bold mb-1"
              >
                Agora falta pouco!
              </b-card-title>
              <manual-cliente
                tooltip
                style="margin-left: 2px;"
              />
            </div>
            <b-card-text class="mb-2">
              Faça a verificação do seu acesso, cadastrando sua senha e entre no portal Hub Auditar
            </b-card-text>

            <!-- form -->
            <validation-observer ref="validacao">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
              >
                <!-- email -->
                <b-form-group
                  label="E-mail"
                  label-for="login-email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="form.login"
                    name="login-email"
                    :disabled="true"
                  />
                </b-form-group>

                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">Nova senha</label>
                  </div>
                  <senha-input
                    v-model="form.novaSenha"
                    required
                  />
                </b-form-group>

                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-confirm-password">Confirmar senha</label>
                  </div>
                  <senha-input
                    v-model="form.confirmarSenha"
                    required
                    :validacao-nome="'Confirmar senha'"
                  />
                  <small class="text-danger">{{ loginError }}</small>
                </b-form-group>

                <!-- submit buttons -->
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  @click="autenticar"
                >
                  Confirmar
                </b-button>
                <div style="padding-top: 10px;">
                  <span>
                    *Padrão de senha esperado: deve conter no mínimo 8 caracteres, letras minúsculas, maiúsculas, símbolos e números.
                  </span>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col style="display: flex; flex-direction: column; justify-content: end;">
            <manual-cliente />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<script>
/* eslint-disable global-require */
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { mapActions } from 'vuex'
import useJwt from '@/auth/jwt/useJwt'
import { clearLoggedIn, updateAbility } from '@/auth/utils'

export default {
  name: 'ConfirmarAcessoExterno',
  components: {
    ValidationObserver,
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
    ManualCliente: () => import('@/app-modulo/comuns/manual-cliente/ManualCliente.vue'),
  },
  data() {
    return {
      form: {
        login: this.$route.query.email,
        novaSenha: '',
        confirmarSenha: '',
        token: this.$route.query.token,
      },
      logo: require('@/assets/images/logo/logocompleta.png'),
      required,
      loginError: '',
    }
  },
  created() {
    clearLoggedIn()
  },
  methods: {
    ...mapActions('empresaExGlobal', ['setEmpresa', 'setEscolherEmpresa']),
    autenticar() {
      this.loginError = ''
      this.$refs.validacao.validate()
        .then(() => {
          this.form.login = this.form.login.trim()
          useJwt.confirmarAcesso(this.form)
            .then(response => {
              useJwt.setToken(response.data.accessToken)
              localStorage.setItem('userData', JSON.stringify(response.data.userData))
              localStorage.setItem('empresaSelecionada', null)
              updateAbility(this.$ability)
              if (response.data.userData.empresas.length > 1) {
                this.setEscolherEmpresa(true)
                this.$router.push({ name: 'selecionar-empresa' })
              } else {
                this.setEmpresa(response.data.userData.empresas[0])
                this.setEscolherEmpresa(false)
                this.$router.push({ name: 'portaldocumentos-externo' })
              }
            })
            .catch(error => {
              this.loginError = error.response.data.message
            })
        })
    },
  },
}
</script>
